
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';

import {
    dataAnalysisProductRecommendConfigList,
    dataAnalysisProductRecommendConfigSaveProduct,
    dataAnalysisProductRecommendConfigSaveRecommendReason,
    dataAnalysisProductRecommendConfigSaveSortDesc,
    dataAnalysisProductRecommendConfigCancelRecommend
} from '@/api/toBApi';
import {
    productpopoverproductlist
} from '@/api/supplier';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-dialog': Dialog,
    }
})
export default class ProductRecommend extends Vue {

    private list = [];
    private keywords = '';
    private state = null;
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private stateList = [
        { value: null, label: '全部' },
        { value: 1, label: '未开始' },
        { value: 0, label: '进行中' },
        { value: 2, label: '已结束' }
    ];

    private selectPop = {
        show: false,
        pageNo: 1,
        pageSize: 5,
        list: [],
        total: 0,
        keywords: '',
        // selectId: '',
        selectData: []
    }
    private productEdit = {
        show: false,
        loading: false,
        reason: ''
    }

    private selectList = [];
    private checkAll = false;

    private mounted() {
        this.doSearch();
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                Keywords: this.keywords.trim(),
                ProductState: this.state,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await dataAnalysisProductRecommendConfigList(params);
            console.log(res)
            this.list = res.Result.Results.map(item => {
                item.visible = false;
                item.showIcon1 = false;
                item.visible1 = false;
                item.showIcon2 = false;
                item.RecommendReasonCopy = item.RecommendReason;
                item.SortDescCopy = item.SortDesc;
                return item;
            });
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }

    private selectionChange(selection){
        this.selectList = selection;
        this.checkAll = this.selectList.length === this.list.length;
    }
    private checkAllChange(e){
        const ref: any = this.$refs['tableData'];
        ref.toggleAllSelection();
    }
    private handleBatchCancel(){
        if (!this.selectList.length){
            this.$message.error('请先选中商品');
            return;
        }
        let ids = this.selectList.map(item=>{
            return item.Id
        })
        this.handleCancelRecommend(ids);
    }

    private handleCancelRecommend(ids){

         this.$confirm('是否确认取消推荐？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            if (this.productEdit.loading) return;
            this.productEdit.loading = true;
            try {
                await dataAnalysisProductRecommendConfigCancelRecommend({ Ids: ids });
                this.$message.success('操作成功');
                this.doSearch();
            } catch (error) {

            } finally{
                this.productEdit.loading = false;
            }
        }).catch(() => {
        });


       
    }

    private cellMouseEnter(row){
        row.showIcon1 = true;
        row.showIcon2 = true;
    }
    private cellMouseLeave(row){
        if (!row.visible){
            row.showIcon1 = false;
        }
        if (!row.visible1){
            row.showIcon2 = false;
        }
    }

    private handleMouseout(record){
        if (record.visible) return;
        record.showIcon1 = false;
    }
    private async handleSaveRecommendText(record){
        if (this.productEdit.loading) return;
        this.productEdit.loading = true;
        try {
            await dataAnalysisProductRecommendConfigSaveRecommendReason({ Id: record.Id, RecommendReason: record.RecommendReasonCopy });
            this.$message.success('操作成功');
            record.visible = false;
            record.showIcon1 = false;
            this.doSearch();
        } catch (error) {

        } finally{
             this.productEdit.loading = false;
        }
    }
    private handleMouseoutSort(record){
        if (record.visible1) return;
        record.showIcon2 = false;
    }
    private async handleSaveSort(record){

        let sort = record.SortDescCopy;
        let sortNum = +sort;
        if (isNaN(sort) || sortNum < 0 || sortNum > 99999){
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }
        if (sort.indexOf('.') > -1){
            this.$message.error('序号请输入0~99999之间，整数');
            return;
        }

        if (this.productEdit.loading) return;
        this.productEdit.loading = true;
        try {
            await dataAnalysisProductRecommendConfigSaveSortDesc({ Id: record.Id, SortDesc: record.SortDescCopy });
            this.$message.success('操作成功');
            record.visible1 = false;
            record.showIcon2 = false;
            this.doSearch();
        } catch (error) {

        } finally{
             this.productEdit.loading = false;
        }
    }
    

    private handleAddProduct() {
        this.selectPop.show = true;
        this.selectPop.keywords = '';
        this.selectPop.pageNo = 1;
        // this.selectPop.selectId = '';
        this.selectPop.selectData = [];
        this.getProductList();

        this.$nextTick(()=>{
            let ref: any = this.$refs['selectPop'];
            ref.clearSelection();
        })
    }
    private handlePopSearch() {
        this.selectPop.pageNo = 1;
        this.getProductList();
    }
    private selectPopChangePage(e) {
        this.selectPop.pageNo = e;
        this.getProductList();
    }
    private radioChange(e, record) {
        console.log(e);
        this.selectPop.selectData = record;
    }
    private handleSelectionChange(list){
        this.selectPop.selectData = list;
    }
    private handleSelect() {
        if (!this.selectPop.selectData.length) {
            this.$message.error('请选择商品');
            return;
        }

        // this.productEdit.reason = '';
        // this.productEdit.show = true;
        this.handleSureEdit();
    }
    private async handleSureEdit() {
        if (this.productEdit.loading) return;
        this.productEdit.loading = true;
        try {
            let ids = this.selectPop.selectData.map(item=>{
                return item.Id
            })
            const res = await dataAnalysisProductRecommendConfigSaveProduct({ Ids: ids, RecommendReason: ''});
            this.$message.success('推荐商品添加成功');
            this.doSearch();
            this.productEdit.show = false;
            this.selectPop.show = false;
            // this.$confirm('推荐商品添加成功。', '提示', {
            //     confirmButtonText: '继续添加',
            //     cancelButtonText: '返回列表',
            //     type: 'warning'
            // }).then(() => {
            //     this.handleAddProduct();
            // }).catch(() => {
            //     this.selectPop.show = false;
            // });

        } catch (error) {

        } finally{
             this.productEdit.loading = false;
        }
    }
    private async getProductList() {
        try {

            let params: any = {
                Skip: (this.selectPop.pageNo - 1) * this.selectPop.pageSize,
                Take: this.selectPop.pageSize,
                Keywords: this.selectPop.keywords.trim(),
                IsOpen: true,
                IsIncludeFinished: false,
            }
            const res: any = await productpopoverproductlist(params);
            this.selectPop.total = res.Result.Total;
            this.selectPop.list = res.Result.Results;
        } catch (e) {

        }
    }

}
